/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";

const AddressFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {values.map((valueItem, index) => {
                const { name, value, settings } = valueItem || {};
                const { style } = settings || {};

                return (
                    <Fragment key={index}>
                        {value && (
                            <DisplayTextOnly
                                label={name}
                                value={value}
                                style={style}
                            />
                        )}
                    </Fragment>
                );
            })}
        </FieldDisplayWrapper>
    );
};
AddressFieldDisplay.displayName = "AddressFieldDisplay";
export { AddressFieldDisplay };
